'use client';

var _CalendarIcon;
import CalendarIcon from '@crehana/compass.icons.outline/Calendar';
import { cn } from "../../../utils";
import { useDateInputLabel } from "./hooks/use-date-input-label";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DateInput = function DateInput(_ref) {
  var selected = _ref.selected,
    className = _ref.className,
    mode = _ref.mode,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    onMaskValue = _ref.onMaskValue,
    _ref$rootElement = _ref.rootElement,
    RootElement = _ref$rootElement === void 0 ? 'button' : _ref$rootElement;
  var label = useDateInputLabel({
    selected: selected,
    placeholder: placeholder,
    onMaskValue: onMaskValue,
    mode: mode
  });
  return /*#__PURE__*/_jsxs(RootElement, {
    className: cn('tw-input data-[state=open]:tw-border-primary-light-500 hover:tw-border-primary-light-500', 'group tw-justify-between', disabled && 'tw-pointer-events-none tw-cursor-default tw-bg-neutral-light-400 tw-text-neutral-light-500 tw-border-none', className),
    disabled: disabled,
    type: "button",
    children: [label, _CalendarIcon || (_CalendarIcon = /*#__PURE__*/_jsx(CalendarIcon, {
      className: "tw-text-neutral-light-600",
      size: 24
    }))]
  });
};